// extracted by mini-css-extract-plugin
export var cardTitle = "_ij-1";
export var commentBubble = "_ij-e";
export var commentForm = "_ij-a";
export var commentInput = "_ij-b";
export var commentLabel = "_ij-d";
export var commentPrompt = "_ij-9";
export var csatCard = "_ij-0";
export var feedbackSection = "_ij-7";
export var starDisabled = "_ij-6";
export var starEmpty = "_ij-5";
export var starFilled = "_ij-4";
export var starWrapper = "_ij-3";
export var starsContainer = "_ij-2";
export var submittedComment = "_ij-c";
export var thankYouText = "_ij-8";